import { Component, h, Host, Listen, Element } from '@stencil/core';
import { BreakpointWidths } from '../../_helpers/breakpoints';

@Component({
	tag: 'ds-content-block-item-legacy',
})
export class ContentBlockItemLegacy {
	@Element()
	el: HTMLDsContentBlockItemElement;
	contentBlock?: HTMLDivElement;
	sidebarColumn?: HTMLDivElement;

	componentDidLoad() {
		this.contentBlock = this.el.querySelector('[data-content]');
		this.sidebarColumn = this.el.querySelector('[data-sidebar-column]');
		this.handleTitlePosition();
	}

	handleTitlePosition = () => {
		if (this.contentBlock && this.sidebarColumn) {
			const isInContentBlock = this.contentBlock.querySelector('h2');
			const isInSidebarColumn = this.sidebarColumn.querySelector('h2');

			if (window.innerWidth <= BreakpointWidths.MD && !isInContentBlock) {
				const title = this.el.querySelector('[data-title]');
				if (title) {
					const clonedTitle = title.cloneNode(true);
					const content = this.el.querySelector('[data-content]');

					content.prepend(clonedTitle);
					title.remove();
				}
			}
			if (window.innerWidth > BreakpointWidths.MD && !isInSidebarColumn) {
				const title = this.el.querySelector('[data-title]');
				if (title) {
					const clonedTitle = title.cloneNode(true);
					const sidebarColumn = this.el.querySelector('[data-sidebar-column]');

					sidebarColumn.prepend(clonedTitle);
					title.remove();
				}
			}
		}
	};

	// Used to move heading from one column to another
	@Listen('resize', { target: 'window', passive: true })
	onResize() {
		this.handleTitlePosition();
	}

	render() {
		return (
			<Host>
				<slot />
			</Host>
		);
	}
}
